/* eslint-disable no-shadow */

import type { Module } from 'vuex';
import type { User } from '@/entities/Entities';
import type { State } from '.';
import { fetchApi } from '@/hooks/fetch';

export interface AuthState {
  user?: User;
  loggedIn: boolean;
}

type AuthModule = Module<AuthState, State>;

const createState = () => ({
  user: undefined,
  loggedIn: false,
});

const getters: AuthModule['getters'] = {
  IS_ADMIN(state: AuthState) {
    return (
      state.user?.roles?.includes('ROLE_ADMIN') || state.user?.roles?.includes('ROLE_SUPER_ADMIN')
    );
  },
  IS_SUPER_ADMIN(state: AuthState) {
    return (
      state.user?.roles?.includes('ROLE_SUPER_ADMIN')
    );
  },
  IS_FINANCE_ADMIN(state: AuthState) {
    return (
      state.user?.roles?.includes('ROLE_FINANCE_ADMIN') || state.user?.roles?.includes('ROLE_SUPER_ADMIN')
    );
  },
};

const mutations: AuthModule['mutations'] = {
  SET_USER(state: AuthState, data: User) {
    state.user = data;
    state.loggedIn = state.user != null;
  },
};

const actions: AuthModule['actions'] = {
  async LOGOUT({ commit }) {
    commit('SET_USER', null);
  },
  async LOAD_USER({ commit }, { userId } = {}) {
    const id = userId ?? 'current';
    const user: User = await fetchApi(`/users/${id}`);

    commit('SET_USER', user);
  },
};

const authModule: AuthModule = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions,
};

export default authModule;
